import React from 'react';
import {
  CircularProgress,
  MenuItem,
  Pagination,
  Select,
  SelectChangeEvent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import EmptyState from '@shared/ui/common/EmptyState';
import { ProductInventory } from '@domain/inventory/models/Inventory';
import { ProductSales } from '@domain/sales/models/Sales';
import { APP_CONFIG } from '../../../../config/app.config';
import ProductTableRow from './ProductTableRow';
import {
  FORECAST_PERIOD_OPTIONS,
  ForecastPeriod,
  ForecastPeriodRange,
} from './utils';

interface ProductTableProps {
  rows: ProductInventory[];
  isLoading: boolean;
  page: number;
  totalPages: number;
  period: ForecastPeriod;
  periodRange: ForecastPeriodRange;
  today: Date;
  salesByProductId: Map<string, ProductSales>;
  onPeriodChange: (period: ForecastPeriod) => void;
  onPageChange: (page: number) => void;
  onOpen: (item: ProductInventory) => void;
}

const ProductTable: React.FC<ProductTableProps> = ({
  rows,
  isLoading,
  page,
  totalPages,
  period,
  periodRange,
  today,
  salesByProductId,
  onPeriodChange,
  onPageChange,
  onOpen,
}) => {
  const colors = APP_CONFIG.ui.theme.colors;

  const handlePeriodChange = (event: SelectChangeEvent) => {
    onPeriodChange(event.target.value as ForecastPeriod);
  };

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: colors.backgroundTint }}>
              <TableCell>
                <Typography variant="body2" noWrap>
                  Product
                </Typography>
              </TableCell>
              {/* <TableCell>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={1}
                >
                  <Typography variant="body2" noWrap>
                    Sales Forecast
                  </Typography>
                  <Select
                    value={period}
                    onChange={handlePeriodChange}
                    size="small"
                    variant="standard"
                    disableUnderline
                    sx={{
                      fontSize: 12,
                      fontWeight: 500,
                      color: colors.secondaryText,
                      '& .MuiSelect-select': {
                        py: 0,
                        pr: '24px !important',
                      },
                    }}
                  >
                    {FORECAST_PERIOD_OPTIONS.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Stack>
              </TableCell> */}
              <TableCell align="right">
                <Typography variant="body2" noWrap>
                  Stock Level
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography variant="body2" noWrap>
                  Status
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={3} align="center" sx={{ py: 6 }}>
                  <CircularProgress size={28} />
                </TableCell>
              </TableRow>
            ) : rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} sx={{ border: 0 }}>
                  <EmptyState
                    title="No products yet"
                    description="Connect a marketplace and sync inventory to see products here."
                  />
                </TableCell>
              </TableRow>
            ) : (
              rows.map((item) => (
                <ProductTableRow
                  key={item.product.id}
                  item={item}
                  periodRange={periodRange}
                  today={today}
                  productSales={salesByProductId.get(item.product.id)}
                  onOpen={onOpen}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {totalPages > 1 && (
        <Stack
          p={2}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Pagination
            count={totalPages}
            page={page}
            onChange={(_, value) => onPageChange(value)}
            color="primary"
            size="large"
            shape="rounded"
            showFirstButton
            showLastButton
          />
        </Stack>
      )}
    </>
  );
};

export default ProductTable;
